<div class="card mb-4 mx-0 mx-sm-4">
  <div class="card-body pb-0" [class.placeholder-glow]="isLoading()">
    <div class="d-flex flex-column flex-lg-row align-items-center">
      <!-- Avatar Section -->
      <div class="text-center text-lg-start mb-4 mb-lg-0">
        <ms-avatar [identity]="member()" [avatarSize]="avatarSize" [avatarShape]="avatarShape" [showUploadControls]="false"
          [isLoading]="isLoading()">
        </ms-avatar>
      </div>

      <!-- Profile Info Section -->
      <div class="flex-grow-1 ms-lg-4 text-center text-lg-start w-100 w-lg-auto min-w-0">
        <div class="d-flex flex-column flex-lg-row align-items-center align-items-lg-start justify-content-between">
          <div class="mb-3 mb-lg-0 me-lg-3 min-w-0 w-100">
            @if (isLoading()) {
            <div class="placeholder col-8 mb-2"></div>
            <div class="placeholder col-6"></div>
            } @else {
            <div class="d-flex align-items-center min-w-0 mb-1 justify-content-center justify-content-lg-start">
              <h2 class="fw-bold mb-0 text-truncate min-w-0" [msTooltip]="fullName()" msTooltipOnlyIfTruncated>
                {{member()?.firstName}} {{member()?.lastName}}
              </h2>
              @if (member()?.status) {
              <div class="ms-2 flex-shrink-0">
                <ms-status-badge [status]="member()?.status" [isLoading]="isLoading()"></ms-status-badge>
              </div>
              }
            </div>

            <div class="w-fit profile-info-mw text-start mx-auto mx-lg-0">
              @if (member()?.mostPermissiveRole) {
              <div class="d-flex align-items-center min-w-0">
                <fa-duotone-icon icon="briefcase" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                <span class="text-truncate min-w-0" [msTooltip]="member()?.mostPermissiveRole ?? ''" msTooltipOnlyIfTruncated>
                  {{member()?.mostPermissiveRole}}
                </span>
              </div>
              }

              @if (member()?.emailAddress) {
              <div class="d-flex align-items-center min-w-0">
                <fa-duotone-icon icon="envelope" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                <span class="text-truncate min-w-0"
                   [msTooltip]="member()?.emailAddress ?? ''" msTooltipOnlyIfTruncated>{{member()?.emailAddress}}</span>
              </div>
              }

              @if (member()?.phoneNumber) {
              <div class="d-flex align-items-center min-w-0">
                <fa-duotone-icon icon="phone" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                <span class="text-truncate min-w-0" [msTooltip]="formattedPhone()" msTooltipOnlyIfTruncated>
                  {{member()?.phoneCountryCode | CountryCode}} {{member()?.phoneNumber | NANPFormattedPhone}} {{member()?.phoneExtension | PhoneExtension}}
                </span>
              </div>
              }
            </div>

            }
          </div>
          <div class="dropdown flex-shrink-0" ifHasChildPermission>
            <button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" [class.placeholder]="isLoading()">
              <span>Actions</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              @if (canShowEditProfile()) {
              <li>
                <button type="button" class="dropdown-item"
                  [class.disabled]="member()?.status === MemberStatuses.Deleted || isCheckingProtection() || isProtectedFromModification()"
                  [disabled]="member()?.status === MemberStatuses.Deleted || isCheckingProtection() || isProtectedFromModification()"
                  (click)="editProfileRequested.emit()">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="edit" secondaryOpacity="0.9" class="me-2" />
                  }Edit Profile
                </button>
              </li>
              }
              @if (shouldShowInviteButton()) {
              <li>
                <a class="dropdown-item" (click)="sendInviteRequested.emit()">
                  <fa-duotone-icon icon="paper-plane" secondaryOpacity="0.9" class="me-2" />Send Invitation
                </a>
              </li>
              }
              @if (!isOwnAccount() || canManageOwnAccount()) {
              <li><hr class="dropdown-divider"></li>
              }
              @if (canShowReactivate()) {
              <li>
                <a class="dropdown-item" [class.disabled]="isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="(isCheckingProtection() || isProtectedFromModification()) ? $event.stopPropagation() : confirmMemberStatusUpdate(MemberStatusActions.Activate)">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />
                  }Activate
                </a>
              </li>
              }
              @else if (canShowDeactivate()) {
              <li>
                <a class="dropdown-item" [class.disabled]="isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="(isCheckingProtection() || isProtectedFromModification()) ? $event.stopPropagation() : confirmMemberStatusUpdate(MemberStatusActions.Deactivate)">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />
                  }Deactivate
                </a>
              </li>
              <!-- DEV-2464: hidden for MMP - restore Suspend when ready
              <li>
                <a class="dropdown-item" (click)="confirmMemberStatusUpdate(MemberStatusActions.Suspend)">
                  <fa-duotone-icon icon="pause" secondaryOpacity="0.9" class="me-2" />Suspend
                </a>
              </li>
              -->
              }
              <!-- DEV-2464: hidden for MMP - restore Suspended-state actions (Deactivate / Unsuspend) when ready
              @else if (member()?.status === MemberStatuses.Suspended) {
              <li>
                <a class="dropdown-item" (click)="confirmMemberStatusUpdate(MemberStatusActions.Deactivate)">
                  <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="confirmMemberStatusUpdate(MemberStatusActions.Unsuspend)">
                  <fa-duotone-icon icon="play" secondaryOpacity="0.9" class="me-2" />Unsuspend
                </a>
              </li>
              }
              -->
              @if (canShowDelete()) {
              <li>
                <a class="dropdown-item"
                  [class.disabled]="member()?.status === MemberStatuses.Deleted || isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(member()?.status === MemberStatuses.Deleted || isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(member()?.status === MemberStatuses.Deleted || isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="member()?.status !== MemberStatuses.Deleted && !isCheckingProtection() && !isProtectedFromModification() ? confirmMemberDeletion() : $event.stopPropagation()">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />
                  }Delete
                </a>
              </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Navigation Tabs -->
  <div class="profile-nav-container mt-4">
    <ms-responsive-tabs [navItems]="navItems() ?? []" (tabChanged)="onTabClick($event)" />
  </div>
</div>

<ms-confirmation-modal #memberProfileHeaderConfirmationModalRef 
    modalId="memberProfileHeaderConfirmationModal"
    [enableNotes]="true" 
    [isNoteRequired]="false"
    confirmButtonText="Yes" 
    cancelButtonText="No"
    [(isSubmitting)]="isSubmitting"
    (confirmed)="confirmationConfirmFunction($event)" 
    (cancelled)="confirmationCancelFunction()" 
/>

<ms-info-modal #memberProfileHeaderInfoModalRef 
    modalId="memberProfileHeaderInfoModal" 
/>
